import {accessGroupEnum, accessItemTypeEnum, projectPrivacyLevelEnum} from '../../../serverClientShared/sharedEnums';

export const cloneArr = (arr) => Array.isArray(arr) ? [...arr] : [];

const extractOwnerId = (owner) => (owner && (owner._id || owner)) && String(owner._id || owner);

export const toOwnerIds = (owners) => (owners || []).map(extractOwnerId).filter(Boolean);

export const initialOwners = (p) => {
    if (Array.isArray(p.ProjectOwners) && p.ProjectOwners.length) return p.ProjectOwners;
    if (p.ProjectOwner) return [p.ProjectOwner];
    return [];
};

export const deriveLevel = (project, sources) => {
    if ((sources || []).includes(accessGroupEnum.GUEST)) return projectPrivacyLevelEnum.PUBLIC;
    else if ((sources || []).includes(accessGroupEnum.WORKSPACE_PUBLIC)) return projectPrivacyLevelEnum.WORKSPACE_PUBLIC;
    return projectPrivacyLevelEnum.PRIVATE;
};

const applyPrivateLevel = (set) => {
    set.delete(accessGroupEnum.WORKSPACE_PUBLIC);
    set.delete(accessGroupEnum.GUEST);
};

const applyWorkspacePublicLevel = (set) => {
    set.add(accessGroupEnum.WORKSPACE_PUBLIC);
    set.delete(accessGroupEnum.GUEST);
};

const applyPublicLevel = (set) => {
    set.add(accessGroupEnum.WORKSPACE_PUBLIC);
    set.add(accessGroupEnum.GUEST);
};

export const applyLevelToAccess = (level, access) => {
    const set = new Set(access.editedAccessSources);
    if (level === projectPrivacyLevelEnum.PRIVATE) applyPrivateLevel(set);
    else if (level === projectPrivacyLevelEnum.WORKSPACE_PUBLIC) applyWorkspacePublicLevel(set);
    else applyPublicLevel(set);
    access.setEditedAccessSources([...set]);
    access.setEditedIsPublic(level !== projectPrivacyLevelEnum.PRIVATE);
};

export const buildSavePayload = (project, edited) => ({
    ProjectIdentifier: project.ProjectIdentifier,
    ProjectName: edited.name,
    ProjectDescription: edited.description,
    Tags: edited.tags,
    ProjectCoverImage: edited.coverImage || null,
    ProjectCoverImageThumb: edited.coverImageThumb || null,
    Default3DModel: edited.default3DModel,
    IsRolesPermittedByDefault: edited.isRolesPermittedByDefault,
    ProjectOwners: toOwnerIds(edited.projectOwners),
    IsPublic: edited.privacyLevel !== projectPrivacyLevelEnum.PRIVATE,
});

export const projectAccessItemRef = (projectId) => ({
    itemId: projectId,
    itemType: accessItemTypeEnum.PROJECT,
    nestedRoute: '',
});
